export const errors = {
  unknown: 0,
  notAuthenticated: 1,
  confirmationLinkInvalid: 2,
  confirmationLinkExpired: 3,
  notAuthorized: 4,
  propertyNotFound: 5
}
